import React, { useState, useEffect, useRef } from 'react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Label } from '../ui/Label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from '../ui/Card';
import { X, User, Mail, Building2, GraduationCap } from 'lucide-react'; // Importando ícones
import { quickSignupAndCheckin } from '../../services/api'; 

function QuickCheckinModal({ isOpen, onClose, onSubmit, eventoId, sessaoId, localSessaoId, initialEmail = '' }) {
    const initialFocusRef = useRef(null);
    const [formData, setFormData] = useState({
        nomeParticipante: '',
        emailParticipante: '',
        grauAcademicoParticipante: '', // ATUALIZADO
        instituicaoParticipante: '',
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen) {
            // Preenche o email se for um email válido vindo da busca
            if (initialEmail && initialEmail.includes('@')) {
                setFormData(prev => ({ ...prev, emailParticipante: initialEmail }));
            } else {
                setFormData(prev => ({ ...prev, emailParticipante: '' }));
            }
            
            // Define o foco no primeiro input
            setTimeout(() => {
                if (initialFocusRef.current) {
                    initialFocusRef.current.focus();
                }
            }, 100);
        }
    }, [initialEmail, isOpen]);

    if (!isOpen) {
        return null;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const payload = {
            ...formData,
            eventoId: parseInt(eventoId),
            localSessaoId: parseInt(localSessaoId),
        };
        try {
            // Chama a função onSubmit que está no AdminCheckinPage, que por sua vez chama a API
            await onSubmit(payload); 
            // Limpa o formulário no sucesso
            setFormData({
                nomeParticipante: '',
                emailParticipante: '',
                grauAcademicoParticipante: '', // ATUALIZADO
                instituicaoParticipante: '',
            });
        } catch (error) {
            // O erro é tratado na página pai, mas garantimos que o botão é reativado
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div 
            className="fixed inset-0 bg-black/60 z-50 flex justify-center items-center p-4"
            role="dialog"
            aria-modal="true"
            aria-labelledby="quick-checkin-title"
        >
            <Card className="w-full max-w-md relative">
                <button 
                    onClick={onClose} 
                    className="absolute top-4 right-4 p-1 rounded-full hover:bg-accent transition-colors"
                    aria-label="Fechar"
                >
                    <X className="h-5 w-5" />
                </button>
                <CardHeader>
                    <CardTitle id="quick-checkin-title" className="mb-2">Cadastro e Check-in Rápido</CardTitle>
                    <CardDescription className="leading-relaxed">
                        Preencha os dados do participante para registrá-lo no evento e fazer o check-in.
                    </CardDescription>
                </CardHeader>
                <form onSubmit={handleSubmit}>
                    <CardContent className="space-y-4">
                        <div className="grid gap-2">
                            <Label htmlFor="nomeParticipante" className="mb-1 flex items-center"><User className="mr-2 h-4 w-4" /> Nome Completo</Label>
                            <Input 
                                id="nomeParticipante" 
                                name="nomeParticipante" 
                                value={formData.nomeParticipante} 
                                onChange={handleChange} 
                                required 
                                ref={initialFocusRef} 
                                placeholder="Nome Completo do Participante"
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="emailParticipante" className="mb-1 flex items-center"><Mail className="mr-2 h-4 w-4" /> Email</Label>
                            <Input 
                                id="emailParticipante" 
                                name="emailParticipante" 
                                type="email" 
                                value={formData.emailParticipante} 
                                onChange={handleChange} 
                                required 
                                placeholder="email@exemplo.com"
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="grauAcademicoParticipante" className="mb-1 flex items-center"><GraduationCap className="mr-2 h-4 w-4" /> Grau Acadêmico (Opcional)</Label>
                            <Input 
                                id="grauAcademicoParticipante" 
                                name="grauAcademicoParticipante" 
                                value={formData.grauAcademicoParticipante} 
                                onChange={handleChange} 
                                placeholder="Ex: Licenciatura, Mestrado"
                            />
                        </div>
                        <div className="grid gap-2">
                            <Label htmlFor="instituicaoParticipante" className="mb-1 flex items-center"><Building2 className="mr-2 h-4 w-4" /> Instituição (Opcional)</Label>
                            <Input 
                                id="instituicaoParticipante" 
                                name="instituicaoParticipante" 
                                value={formData.instituicaoParticipante} 
                                onChange={handleChange} 
                                placeholder="Nome da Instituição"
                            />
                        </div>
                    </CardContent>
                    <CardFooter className="flex justify-end gap-2">
                        <Button type="button" variant="secondary" onClick={onClose} disabled={isSubmitting}>
                            Cancelar
                        </Button>
                        <Button type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'A processar...' : 'Cadastrar e Fazer Check-in'}
                        </Button>
                    </CardFooter>
                </form>
            </Card>
        </div>
    );
}

export default QuickCheckinModal;